<template>
    <div>
        <Header/>
        <i-container fluid>
            <i-layout>
                <i-layout-header class="_padding-left-0 _padding-right-0">
                    <LCDForm @filterClicked="onClickFilter" @clearFilterClicked="onClickClearFilter"/>
                </i-layout-header>

                <i-layout-content>
                  <LCDContent :totalItems="paginationItems" :filtered-database="filteredDatabase"></LCDContent>
                </i-layout-content>

                <br>
                <i-layout-footer><i class="far fa-copyright"></i>Faculty of Mathematics, Physics and Informatics, Comenius University in Bratislava, created by <a href="https://fmph.uniba.sk/en/microsites/daa/division-of-astronomy-and-astrophysics/research/space-debris/">Division of Astronomy and Astrophysics</a>, hosted by <a href="http://www.astros.eu">Astros Solutions s.r.o.</a></i-layout-footer>
            </i-layout>
        </i-container>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import LCDForm from '@/components/LCDForm'
    import LCDContent from '@/components/Content'
    import database from '@/assets/database'

    export default {
        name: 'Main',
        components: {
            Header,
            LCDForm,
            LCDContent
        },
        data() {
            return {
                originalDatabaseLength: {},
                paginationItems: {
                    type: Number
                },
                database: {},
                filteredDatabase: {}
            }
        },
        methods: {
            onClickFilter(value) {
                let form = value;

                if (form.valid) {
                    let filteredJson = {};

                    let cospar = form.cospar.value;
                    let norad = form.norad.value;
                    let minAbsMag = form.minam.value;
                    let maxAbsMag = form.maxam.value;

                    if (minAbsMag === "") minAbsMag = 0;
                    if (maxAbsMag === "") maxAbsMag = Infinity;
                    if (norad === "") norad = -1;
                    if (cospar !== "") cospar = cospar.toLowerCase();

                    for (let i in this.database) {
                        let object = this.database[i];
                        // object["display"] = false;
                        if (object["cospar"] !== undefined) {
                          if ((object["cospar"].toLowerCase().indexOf(cospar.toLowerCase()) > -1) ||
                            (object["object-name"] !== undefined &&
                              object["object-name"].toLowerCase().indexOf(cospar.toLowerCase()) > -1)) {
                            if (norad === -1 || object["norad"] === norad) {
                              if (parseFloat(object["Hejduk_med_AbsMag"]) >= parseFloat(minAbsMag) &&
                                parseFloat(object["Hejduk_med_AbsMag"]) <= parseFloat(maxAbsMag)) {
                                filteredJson[i] = object;
                              }
                            }
                          }
                        }
                    }

                    this.filteredDatabase = filteredJson;
                    this.paginationItems = Object.keys(filteredJson).length;
                } else console.log("The form is invalid.")
            },
            onClickClearFilter(value) {
                this.paginationItems = this.originalDatabaseLength;
                this.filteredDatabase = this.database;
            }
        },
        created: function() {
            this.paginationItems = this.originalDatabaseLength = Object.keys(database).length;
            this.filteredDatabase = this.database = database;
        }
    }
</script>

<style scoped>
    .layout-footer {
        background-color: transparent;
        font-size: .75em;
        color: #ced4db;
    }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue